export default __webpack_public_path__ + "static/media/biconomy-white.ed1865ad.svg";